<div style="display:none;" class="miaLesson">assets/mia/mialessons/Meetinstrumentwelcome.json</div>
<div class="welcome"> Hallo, welkom bij MIA</div>

